/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  invalidEmptyValueText: {
    id: 'elasticSearchConfigFields.invalidEmptyValueText',
    defaultMessage: `Value can't be empty.`
  },
  invalidJsonArrayValue: {
    id: 'elasticSearchConfigFields.invalidArrayValue',
    defaultMessage: `Please provide a valid JSON array of objects.`
  },
  invalidJsonObjectValue: {
    id: 'elasticSearchConfigFields.invalidObjectValue',
    defaultMessage: `Please provide a valid JSON object.`
  },
  configInstruction: {
    id: 'elasticSearchConfigFields.configInstruction',
    defaultMessage:
      'Specify the {name} fields you want to map to the title, body, and URL of the search response.'
  },
  fieldPlaceholder: {
    id: 'elasticSearchConfigFields.fieldPlaceholder',
    defaultMessage: 'Field name, ex. document.info.id'
  },
  fieldTitle: {
    id: 'elasticSearchConfigFields.fieldTitle',
    defaultMessage: 'Title'
  },
  fieldBody: {
    id: 'elasticSearchConfigFields.fieldBody',
    defaultMessage: 'Body'
  },
  fieldUrl: {
    id: 'elasticSearchConfigFields.fieldUrl',
    defaultMessage: 'URL (optional)'
  },
  dropdownAdvancedSettings: {
    id: 'elasticSearchConfigFields.dropdownAdvancedSettings',
    defaultMessage: 'Advanced Elasticsearch settings'
  },
  fieldFilter: {
    id: 'elasticSearchConfigFields.fieldFilter',
    defaultMessage:
      'Configure the custom result filter for Elasticsearch. This should be defined as an array of objects.'
  },
  fieldQueryBody: {
    id: 'elasticSearchConfigFields.fieldQueryBody',
    defaultMessage:
      'Configure the query body for Elasticsearch. This should be defined as an object.'
  }
});
